import { ENVIRONMENT, type EnvType } from '../../infra/environment'
import { featureFlags, type FeatureFlagType } from './constants.featureFlags'

/**
 * @deprecated Use https://github.com/loadsmart/carrier-web/wiki/Remote-Configs instead
 */
export function createFeatureFlagManager(initialFlags: FeatureFlagType) {
  let features = { ...initialFlags }

  function isEnabledForEnv(
    featureName: keyof typeof initialFlags,
    config?: { currentEnv: EnvType }
  ): boolean {
    const currentEnv = config?.currentEnv || ENVIRONMENT
    const desiredFeature = features[featureName]

    if (!desiredFeature) {
      console.debug(
        `[isFeatureEnabledForEnv] feature ${featureName} not enabled for ${currentEnv} or not registered`
      )
      return false
    }

    return desiredFeature.env.includes(currentEnv)
  }

  return {
    isEnabledForEnv,
  }
}

export const featureFlagManager = createFeatureFlagManager(featureFlags)
